import { render, staticRenderFns } from "./sectionDropper.vue?vue&type=template&id=1cba2c4e"
import script from "./sectionDropper.vue?vue&type=script&lang=js"
export * from "./sectionDropper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports